export default __webpack_public_path__ + "images/4Q.40ab5b4.png";